<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="ch00_fm02"></a><a id="page_ii"></a><span class="small">INTERSECTIONS</span><br/>Transdisciplinary Perspectives on Genders and Sexualities<br/>General Editors: Michael Kimmel and Suzanna Walters</p>
<p class="center"><em>Sperm Counts: Overcome by Man’s Most Precious Fluid</em><br/>Lisa Jean Moore</p>
<p class="center"><em>The Sexuality of Migration:<br/>Border Crossings and Mexican Immigrant Men</em><br/>Lionel Cantú, Jr.<br/>Edited by Nancy A. Naples and Salvador Vidal-Ortiz</p>
<p class="center"><em>Moral Panics, Sex Panics:<br/>Fear and the Fight over Sexual Rights</em><br/>Edited by Gilbert Herdt</p>
<p class="center"><em>Out in the Country:<br/>Youth, Media, and Queer Visibility in Rural America</em><br/>Mary L. Gray</p>
<p class="center"><em>Sapphistries: A Global History of Love between Women</em><br/>Leila J. Rupp</p>
<p class="center"><em>Strip Club: Gender, Power, and Sex Work</em><br/>Kim Price-Glynn</p>
<p class="center"><em>Sexualities for Life: From Adolescence to the Golden Years, How Sex Changes throughout Our Lives</em><br/>Edited by Laura M. Carpenter and John DeLamater</p>
<p class="center"><em>The Bully Society:<br/>Shootings, Gender, and Related Violence in American Schools</em><br/>Jessie Klein</p>
<p class="center"><em>One Marriage under God:<br/>The Campaign to Promote Marriage in America</em><br/>Melanie Heath</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?6866dda7